// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomArrowCircleLeft = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      opacity: '0.25',
      d: 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      opacity: '0.75',
      d: 'M13.2599 16.2799C13.0699 16.2799 12.8799 16.2099 12.7299 16.0599L9.19992 12.5299C8.90992 12.2399 8.90992 11.7599 9.19992 11.4699L12.7299 7.93991C13.0199 7.64991 13.4999 7.64991 13.7899 7.93991C14.0799 8.22991 14.0799 8.70991 13.7899 8.99991L10.7899 11.9999L13.7899 14.9999C14.0799 15.2899 14.0799 15.7699 13.7899 16.0599C13.6499 16.2099 13.4599 16.2799 13.2599 16.2799Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomArrowCircleLeft };
